import React from "react";

import Navbar from "./Navbar";

import { MyCustomContextHook } from "./Context";

export const Submenu = () => {
  //Importing Context Values

  const {
    isSubmenuOpen,

    page: { links },

    location,

    submenuOfSubmenus,

    closeExtraSubmenu,
  } = MyCustomContextHook();

  const container = React.useRef(null);

  const [columns, setColumns] = React.useState("");

  React.useEffect(() => {
    setColumns("submenu-center");

    const submenu = container.current;

    const { center, bottom } = location;

    submenu.style.left = `${center}px`;

    submenu.style.top = `${bottom}px`;
  }, [location, links, columns]);

  const displayExtraSubmenu = (e) => {
    const label = e.target.textContent;

    const tapBtn = e.target.getBoundingClientRect();

    const subCenter = tapBtn.right + 17;

    const subBottom = tapBtn.bottom - 27;

    submenuOfSubmenus(label, { subCenter, subBottom });
  };

  const removeExtraSubmenu = (e) => {
    if (!e.target.classList.contains("label-link")) {
      closeExtraSubmenu();
    }
  };

  return (
    <>
      <Navbar removeExtraSubmenu={removeExtraSubmenu} />

      <aside
        className={`${isSubmenuOpen ? "submenu show" : "submenu"}`}
        ref={container}
        onMouseEnter={removeExtraSubmenu}
      >
        <div className={`submenu-center`}>
          {links.map((link, index) => {
            const { label, button, icons } = link;

            return (
              <>
             
                <div className="write-up" key={index}>
                  <div
                    className={`label-link ${
                      button ? "label-link-center" : "label-link-left"
                    }`}
                    onMouseOver={button ? null : displayExtraSubmenu}
                  >
                    {label}

                    {button ? (
                      <div className="extra-submenu-btn">
                        <button className="submenu-btn">{button}</button>
                      </div>
                    ) : null}
                  </div>
                  
                
                </div>
              </>
            );
          })}
        </div>
      </aside>
    </>
  );
};
